<script>
export default {
	
}
</script>
<template>
	<div class="container">
		<h4 class="text-right text-primary m-0 font-weight-light"> <span class="icon-home"></span> GRUPO COMERCIAL ANFORAMA I 3 CLIENTES</h4>
		<h4 class="m-0 font-weight-light">Mis grupos y clientes</h4>

		<div class="pf-section-gradient mb-2">
			<div class="d-flex">
				<div class="ml-auto d-flex align-items-end">
					<input type="text" class="border-none"> <span class="px-2">Buscar</span> <button class="btn btn-sm btn-primary"><span class="icon-search"></span></button>
				</div>
			</div>
		</div>
		<div class="pf-section p-0">
		
		</div>
		<div class="pf-section-gradient mb-2">
			<div class="d-flex">
				<div class="ml-auto d-flex align-items-end">
					<span class="px-2 small">Primero</span>
					<span class="px-2 small">Anterior</span>
					<span class="px-2 small">Siguiente</span>
					<span class="px-2 small">Último</span>
				</div>
			</div>
		</div>
		<div class="d-flex mb-2">
			<div class="ml-auto d-flex">
				<button class="btn btn-sm btn-primary">Elementos Eliminados</button>
				<button class="btn btn-sm btn-primary ml-2">Nuevo análisis</button>
			</div>
		</div>

		<div class="pf-section p-2 d-flex rounded">
			<div class="d-flex align-items-center">
				<span class="px-2 small">Contactos</span>|
				<span class="px-2 small">Docuementación</span>|
				<span class="px-2 small">FAQs</span>|
				<span class="px-2 small">v9.0</span>
			</div>
		</div>
	</div>
</template>